import React, { Fragment, forwardRef, useEffect, useState } from 'react';
import MainLineChart from '../Charts/MainLineChart';
import MainBarChart from '../Charts/MainBarChart';
import MainTreeMapChart from '../Charts/MainTreeMapChart';
import MostTradedStockTable from '../Tables/MostTradedStockTable';
import axios from '../../axios';
import { Menu, Transition } from '@headlessui/react';
import DatePicker from 'react-datepicker';
import { CSVLink } from 'react-csv';

import 'react-datepicker/dist/react-datepicker.css';
import MainColumnChart from '../Charts/MainColumnChart';

const orderBookData = {
	total: '549,856.37',
	sells: [
		{
			price: '554000.25',
			amount: '1627'
		},
		{
			price: '554000.25',
			amount: '1427'
		},
		{
			price: '554000.25',
			amount: '1227'
		},
		{
			price: '554000.25',
			amount: '1027'
		},
		{
			price: '554000.25',
			amount: '827'
		},
		{
			price: '554000.25',
			amount: '627'
		}
	],
	buys: [
		{
			price: '454600.09',
			amount: '989'
		},
		{
			price: '454600.09',
			amount: '789'
		},
		{
			price: '454600.09',
			amount: '589'
		},
		{
			price: '454600.09',
			amount: '389'
		},
		{
			price: '454600.09',
			amount: '189'
		},
		{
			price: '454600.09',
			amount: '89'
		}
	]
};

function convertDateFormatWithAddedDay(inputDate) {
	const date = new Date(inputDate);

	const year = date.getFullYear();
	const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Month is zero-indexed
	const day = date.getDate().toString().padStart(2, '0');

	const formattedDate = `${year}-${month}-${day}`;

	return formattedDate;
}

function ConvertData(params) {
	const date = new Date(params);

	const options = {
		year: 'numeric',
		month: 'short',
		day: 'numeric'
	};

	const formattedDate = date.toLocaleString('en-US', options);
	return formattedDate;
}

function Analytics() {
	const [totalRegisteredUsers, setTotalRegisteredUsers] = useState(0);
	const [percentChangeRegisteredUsers, setPercentChangeRegisteredUsers] = useState(0);
	const [totalAssetUnderMgt, setTotalAssetUnderMgt] = useState(0);
	const [percentChangeTotalAssetUnderMgt, setPercentChangeTotalAssetUnderMgt] = useState(0);
	const [totalTransactions, setTotalTransactions] = useState(0);
	const [percentageChangeTotalTransactions, setPercentageChangeTotalTransactions] = useState(0);
	const [averageDailyActiveUsers, setAverageDailyActiveUsers] = useState(0);
	const [percentageChangeDailyActiveUsers, setPercentageChangeDailyActiveUsers] = useState(0);
	// const [topPerformingStock, setTopPerformingStock] = useState([])
	const [mostTradedStock, setMostTradedStock] = useState([]);
	// const [allLinegraphData, setAllLineGraphData] = useState(null)
	const [lineGraphFilter1, setLineGraphFilter1] = useState('positions_data');
	const [lineGraphFilter2, setLineGraphFilter2] = useState('registered_users');
	const [lineGraphDaysFilter, setLineGraphDaysFilter] = useState('last_month_data');
	const [lineGraphData, setLineGraphData] = useState([]);
	const [volumeData, setVolumeData] = useState({});
	const [openDatePicker, setOpenDatePicker] = useState(false);
	const [tradingVolumeKeys, setTradingVolumeKeys] = useState([]);
	const [startDate, setStartDate] = useState(new Date());
	const [endDate, setEndDate] = useState(new Date());
	const [firstDate, setFirstDate] = useState(null);
	const [secondDate, setSecondDate] = useState(null);
	const [barChartFilter, setBarChartFilter] = useState('AIRTELAFRI');
	const [name, setName] = useState('');
	const [chartSource, setChartSource] = useState('NGX');
	const [isTransitioning, setIsTransitioning] = useState(false);
	
	const handleChartSourceChange = async (newSource) => {
		if (newSource === chartSource || isTransitioning) return;
		
		setIsTransitioning(true);
		
		try {
			// API call to update chart source
			await axios.post('https://api-hamma-f0bcaabf77ea.herokuapp.com/portfolio/admin/toggle-data-source/', {
				source: newSource
			});
			
			setChartSource(newSource);
		} catch (error) {
			console.error('Error updating chart source:', error);
			// Optionally show an error message to user
		} finally {
			setIsTransitioning(false);
		}
	};
	
	const onChange = dates => {
		const [start, end] = dates;
		setFirstDate(convertDateFormatWithAddedDay(start));
		setSecondDate(convertDateFormatWithAddedDay(end));
		setStartDate(start);
		setEndDate(end);
	};

	let body = {
		totalRegisteredUsers,
		percentChangeRegisteredUsers,
		totalAssetUnderMgt,
		percentChangeTotalAssetUnderMgt,
		totalTransactions,
		percentageChangeTotalTransactions,
		averageDailyActiveUsers,
		percentageChangeDailyActiveUsers,
		mostTradedStock,
		lineGraphData,
		volumeData
	};

	const exportData = (data, fileName, type) => {
		// Create a link and download the file
		const blob = new Blob([data], { type });
		const url = window.URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = url;
		a.download = fileName;
		a.click();
		window.URL.revokeObjectURL(url);
	};

	const [totalSellAmount, setTotalSellAmount] = useState(0);
	console.log(lineGraphData);
	console.log(volumeData);

	const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
		<button className="bg-[#F1F1F1]" onClick={onClick} ref={ref}>
			{value}
		</button>
	));

	useEffect(() => {
		setTotalSellAmount(
			orderBookData.sells.reduce((accumulator, currentValue) => {
				// Convert amount from string to number and add to the accumulator
				return accumulator + Number(currentValue.amount);
			}, 0)
		);
		setFirstDate(convertDateFormatWithAddedDay(new Date()));
		setSecondDate(convertDateFormatWithAddedDay(new Date()));
	}, []);
	useEffect(() => {
		axios.get('https://api-hamma-f0bcaabf77ea.herokuapp.com/portfolio/admin/toggle-data-source/').then(res => {
			setChartSource(res.data.source);
		}).catch(err => {
			console.log(err);
		});
	}, []);

	useEffect(() => {
		axios.get('analytics/')
			.then(res => {
				console.log(res);
				setTotalRegisteredUsers(res.data.total_registered_users);
				setPercentChangeRegisteredUsers(res.data.percentage_change_registered_users);
				setTotalAssetUnderMgt(res.data.total_assets_under_mgmt);
				setPercentChangeTotalAssetUnderMgt(res.data.percentage_change_assets_under_mgmt);
				setTotalTransactions(res.data.total_transactions);
				setPercentageChangeTotalTransactions(res.data.percentage_change_total_transactions);
				setAverageDailyActiveUsers(res.data.average_daily_active_users);
				setPercentageChangeDailyActiveUsers(res.data.percentage_change_daily_active_users);
				// setTopPerformingStock(res.data.top_performing_stock)
				setMostTradedStock(res.data.most_traded_stock);
			})
			.catch(err => {
				console.log(err);
			});
		axios.get('analytics/graph/')
			.then(res => {
				console.log(res.data);
				setVolumeData(res.data.volume_data);
				setLineGraphData(res.data[lineGraphDaysFilter]);
				// setAllLineGraphData({last_week_data:res.data.last_week_data, last_month_data:res.data.last_month_data, last_3_months_data:res.data.last_3_months_data, last_year_data:res.data.last_year_data})
				setTradingVolumeKeys(Object.keys(res.data.volume_data));
			})
			.catch(err => {
				console.log(err);
			});

		axios.get('https://api-hamma-f0bcaabf77ea.herokuapp.com/auth/profile/')
			.then(res => {
				console.log(res);
				setName(res.data.user.firstname);
				localStorage('user_email', res.data.user.email);
			})
			.catch(err => {
				console.log(err);
			});
	}, [lineGraphDaysFilter]);

	const lineGraphFilterItems = [
		{
			value: 'registered_users',
			label: 'Total Verified Users',
			labelSecond: 'Daily Verified Users',
			labelThird: 'Weekly Verified Users',
			labelForth: 'Monthly Verified Users'
		},
		{
			value: 'transaction_data',
			label: 'Total Transactions',
			labelSecond: 'Daily Transactions',
			labelThird: 'Weekly Transactions',
			labelForth: 'Monthly Transactions'
		},
		{
			value: 'user_activity_data',
			label: 'Total Active Users',
			labelSecond: 'Daily Active Users',
			labelThird: 'Weekly Active Users',
			labelForth: 'Monthly Active Users'
		},
		{
			value: 'positions_data',
			label: 'Total Closed Positions',
			labelSecond: 'Daily Closed Positions',
			labelThird: 'Weekly Closed Positions',
			labelForth: 'Monthly Closed Positions'
		}
	];

	const lineGraphDaysFilterItems = [
		{
			value: 'last_week_data',
			label: 'Last 7 days'
		},
		{
			value: 'last_month_data',
			label: 'Last 30 days'
		},
		{
			value: 'last_3_months_data',
			label: 'Last 3 months'
		},
		{
			value: 'last_year_data',
			label: 'Last 1 year'
		},
		{
			value: 'total_users_data',
			label: 'Total'
		}
	];

	return (
		<div className="mt-[2rem] pb-[5.25rem]">
			<div className="relative w-[100%]">
				<div className="bg-[#0FB23C] lg:px-[2rem] px-[1rem] relative flex flex-col lg:flex-row justify-between items-center pt-[1.5rem] pb-[4rem] rounded-b-[0.75rem]">
					<div>
						<h1 className="flex items-center gap-[0.62rem] font-poppins text-white lg:text-[2rem] text-[1.25rem] font-bold">
							Hello {name}! <img className="lg:w-[3rem] w-[2rem] lg:h-[3rem] h-[2rem]" src="https://res.cloudinary.com/ddlupbcws/image/upload/v1700689685/Waving_Hand_g0gh1q.webp" alt="" />
						</h1>
						<p className="font-poppins text-white text-[1rem] lg:mt-[0.62rem] mt-[1rem]">Welcome to your admin dashboard where you can manage everything</p>
					</div>
					<svg className="absolute bottom-0 lg:right-80 right-[12rem]" xmlns="http://www.w3.org/2000/svg" width="155" height="84" viewBox="0 0 155 84" fill="none">
						<circle cx="77.5" cy="77.5" r="77.5" fill="white" fill-opacity="0.13" />
					</svg>
					<svg className="absolute top-0 right-72" xmlns="http://www.w3.org/2000/svg" width="41" height="26" viewBox="0 0 41 26" fill="none">
						<circle cx="20.5" cy="20.5" r="20.5" transform="matrix(-1 0 0 1 41 -15)" fill="white" fill-opacity="0.13" />
					</svg>
					<svg className="absolute top-0 lg:right-10 right-0" xmlns="http://www.w3.org/2000/svg" width="155" height="104" viewBox="0 0 155 104" fill="none">
						<circle cx="77.5" cy="26.5" r="77.5" fill="white" fill-opacity="0.13" />
					</svg>
					<div className="flex gap-[0.5rem] mt-10">
						{lineGraphData && (
							<CSVLink data={lineGraphData} filename={'users_analytics_data.csv'}>
								<button className="font-poppins text-[1rem] text-[#16161699] font-semibold lg:px-[2rem] px-[1.3rem] py-[0.75rem] rounded-[0.75rem] bg-[#FFFFFF66]">Export to CSV</button>
							</CSVLink>
						)}
						<button onClick={() => exportData(JSON.stringify(body), 'analytics_data.json', 'application/json')} className="cursor-pointer z-10 font-poppins text-[1rem] text-[#16161699] font-semibold lg:px-[2rem] px-[1.3rem] py-[0.75rem] rounded-[0.75rem] bg-[#FFFFFF66]">
							Export to JSON
						</button>
					</div>
				</div>
				<div className="flex lg:justify-between w-[100%] no-scrollbar overflow-x-scroll items-center gap-[2rem] absolute lg:top-40 top-[15rem] lg:px-[2rem] px-[1rem]">
					<div className="shrink-0 flex items-center gap-[0.5rem] bg-white rounded-[0.75rem] p-[1.5rem]">
						<div className="bg-[#E4EFF9] w-[3.625rem] h-[3.625rem] rounded-full flex items-center justify-center">
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="21" viewBox="0 0 16 21" fill="none">
								<path d="M0 21C0 18.8783 0.842855 16.8434 2.34315 15.3431C3.84344 13.8429 5.87827 13 8 13C10.1217 13 12.1566 13.8429 13.6569 15.3431C15.1571 16.8434 16 18.8783 16 21H0ZM8 12C4.685 12 2 9.315 2 6C2 2.685 4.685 0 8 0C11.315 0 14 2.685 14 6C14 9.315 11.315 12 8 12Z" fill="#005FB6" />
							</svg>
						</div>
						<div className="flex flex-col gap-[0.25rem] font-poppins">
							<p className="text-[0.875rem] font-semibold text-[#161616]">{totalRegisteredUsers.toLocaleString()}</p>
							<p className="text-[0.75rem] text-[#16161699]">Total Verified Users</p>
							<p className="flex items-center gap-[0.62rem] text-[0.75rem] text-[#16161699]">
								{percentChangeRegisteredUsers > 0 ? (
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
										<path fill-rule="evenodd" clip-rule="evenodd" d="M14.6664 4.66V7.33333C14.6664 7.46517 14.6273 7.59403 14.5541 7.70364C14.4808 7.81325 14.3767 7.89867 14.2549 7.94912C14.1331 7.99957 13.9991 8.01277 13.8698 7.98706C13.7405 7.96134 13.6217 7.89787 13.5284 7.80467L12.6664 6.94267L9.13778 10.4713C9.01276 10.5963 8.84323 10.6665 8.66645 10.6665C8.48967 10.6665 8.32014 10.5963 8.19512 10.4713L5.99978 8.276L2.47112 11.8047C2.34538 11.9261 2.17698 11.9933 2.00218 11.9918C1.82738 11.9903 1.66018 11.9202 1.53657 11.7965C1.41297 11.6729 1.34285 11.5057 1.34133 11.3309C1.33981 11.1561 1.40701 10.9877 1.52845 10.862L5.52845 6.862C5.65347 6.73702 5.82301 6.66681 5.99978 6.66681C6.17656 6.66681 6.3461 6.73702 6.47112 6.862L8.66645 9.05733L11.7238 6L10.8618 5.138C10.7686 5.04477 10.7051 4.92599 10.6794 4.79669C10.6537 4.66739 10.6669 4.53336 10.7173 4.41156C10.7678 4.28976 10.8532 4.18565 10.9628 4.1124C11.0724 4.03914 11.2013 4.00003 11.3331 4H13.9998L14.0318 4.00067C14.2021 4.00819 14.3629 4.08092 14.4811 4.20378C14.5992 4.32663 14.6656 4.49022 14.6664 4.66067V4.66Z" fill="#0FB23C" />
									</svg>
								) : (
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
										<path fill-rule="evenodd" clip-rule="evenodd" d="M14.6664 11.34V8.66667C14.6664 8.53483 14.6273 8.40597 14.5541 8.29636C14.4808 8.18675 14.3767 8.10133 14.2549 8.05088C14.1331 8.00043 13.9991 7.98723 13.8698 8.01294C13.7405 8.03866 13.6217 8.10213 13.5284 8.19533L12.6664 9.05733L9.13778 5.52867C9.01276 5.40369 8.84323 5.33348 8.66645 5.33348C8.48967 5.33348 8.32014 5.40369 8.19512 5.52867L5.99978 7.724L2.47112 4.19533C2.34538 4.07389 2.17698 4.0067 2.00218 4.00822C1.82738 4.00974 1.66018 4.07985 1.53657 4.20345C1.41297 4.32706 1.34285 4.49427 1.34133 4.66907C1.33981 4.84386 1.40701 5.01227 1.52845 5.138L5.52845 9.138C5.65347 9.26298 5.82301 9.33319 5.99978 9.33319C6.17656 9.33319 6.3461 9.26298 6.47112 9.138L8.66645 6.94267L11.7238 10L10.8618 10.862C10.7686 10.9552 10.7051 11.074 10.6794 11.2033C10.6537 11.3326 10.6669 11.4666 10.7173 11.5884C10.7678 11.7102 10.8532 11.8143 10.9628 11.8876C11.0724 11.9609 11.2013 12 11.3331 12H13.9998L14.0318 11.9993C14.2021 11.9918 14.3629 11.9191 14.4811 11.7962C14.5992 11.6734 14.6656 11.5098 14.6664 11.3393V11.34Z" fill="#B20F19" />
									</svg>
								)}{' '}
								<span className={`${percentChangeRegisteredUsers > 0 ? 'text-[#0FB23C]' : 'text-[#B20F19]'}`}>{percentChangeRegisteredUsers}%</span>
								Last month
							</p>
						</div>
					</div>
					<div className="shrink-0 flex items-center gap-[0.5rem] bg-white rounded-[0.75rem] p-[1.5rem]">
						<div className="bg-[#E4F9EB] w-[3.625rem] h-[3.625rem] rounded-full flex items-center justify-center">
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
								<path d="M17.293 2.293C17 2.586 17 3.057 17 4V17C17 17.943 17 18.414 17.293 18.707C17.586 19 18.057 19 19 19C19.943 19 20.414 19 20.707 18.707C21 18.414 21 17.943 21 17V4C21 3.057 21 2.586 20.707 2.293C20.414 2 19.943 2 19 2C18.057 2 17.586 2 17.293 2.293ZM10 7C10 6.057 10 5.586 10.293 5.293C10.586 5 11.057 5 12 5C12.943 5 13.414 5 13.707 5.293C14 5.586 14 6.057 14 7V17C14 17.943 14 18.414 13.707 18.707C13.414 19 12.943 19 12 19C11.057 19 10.586 19 10.293 18.707C10 18.414 10 17.943 10 17V7ZM3.293 9.293C3 9.586 3 10.057 3 11V17C3 17.943 3 18.414 3.293 18.707C3.586 19 4.057 19 5 19C5.943 19 6.414 19 6.707 18.707C7 18.414 7 17.943 7 17V11C7 10.057 7 9.586 6.707 9.293C6.414 9 5.943 9 5 9C4.057 9 3.586 9 3.293 9.293ZM3 21.25C2.80109 21.25 2.61032 21.329 2.46967 21.4697C2.32902 21.6103 2.25 21.8011 2.25 22C2.25 22.1989 2.32902 22.3897 2.46967 22.5303C2.61032 22.671 2.80109 22.75 3 22.75H21C21.1989 22.75 21.3897 22.671 21.5303 22.5303C21.671 22.3897 21.75 22.1989 21.75 22C21.75 21.8011 21.671 21.6103 21.5303 21.4697C21.3897 21.329 21.1989 21.25 21 21.25H3Z" fill="#00AD3B" />
							</svg>
						</div>
						<div className="flex flex-col gap-[0.25rem] font-poppins">
							<p className="text-[0.875rem] font-semibold text-[#161616]">N{totalAssetUnderMgt.toLocaleString()}</p>
							<p className="text-[0.75rem] text-[#16161699]">Total Closed Positions</p>
							<p className="flex items-center gap-[0.62rem] text-[0.75rem] text-[#16161699]">
								{percentChangeTotalAssetUnderMgt > 0 ? (
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
										<path fill-rule="evenodd" clip-rule="evenodd" d="M14.6664 4.66V7.33333C14.6664 7.46517 14.6273 7.59403 14.5541 7.70364C14.4808 7.81325 14.3767 7.89867 14.2549 7.94912C14.1331 7.99957 13.9991 8.01277 13.8698 7.98706C13.7405 7.96134 13.6217 7.89787 13.5284 7.80467L12.6664 6.94267L9.13778 10.4713C9.01276 10.5963 8.84323 10.6665 8.66645 10.6665C8.48967 10.6665 8.32014 10.5963 8.19512 10.4713L5.99978 8.276L2.47112 11.8047C2.34538 11.9261 2.17698 11.9933 2.00218 11.9918C1.82738 11.9903 1.66018 11.9202 1.53657 11.7965C1.41297 11.6729 1.34285 11.5057 1.34133 11.3309C1.33981 11.1561 1.40701 10.9877 1.52845 10.862L5.52845 6.862C5.65347 6.73702 5.82301 6.66681 5.99978 6.66681C6.17656 6.66681 6.3461 6.73702 6.47112 6.862L8.66645 9.05733L11.7238 6L10.8618 5.138C10.7686 5.04477 10.7051 4.92599 10.6794 4.79669C10.6537 4.66739 10.6669 4.53336 10.7173 4.41156C10.7678 4.28976 10.8532 4.18565 10.9628 4.1124C11.0724 4.03914 11.2013 4.00003 11.3331 4H13.9998L14.0318 4.00067C14.2021 4.00819 14.3629 4.08092 14.4811 4.20378C14.5992 4.32663 14.6656 4.49022 14.6664 4.66067V4.66Z" fill="#0FB23C" />
									</svg>
								) : (
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
										<path fill-rule="evenodd" clip-rule="evenodd" d="M14.6664 11.34V8.66667C14.6664 8.53483 14.6273 8.40597 14.5541 8.29636C14.4808 8.18675 14.3767 8.10133 14.2549 8.05088C14.1331 8.00043 13.9991 7.98723 13.8698 8.01294C13.7405 8.03866 13.6217 8.10213 13.5284 8.19533L12.6664 9.05733L9.13778 5.52867C9.01276 5.40369 8.84323 5.33348 8.66645 5.33348C8.48967 5.33348 8.32014 5.40369 8.19512 5.52867L5.99978 7.724L2.47112 4.19533C2.34538 4.07389 2.17698 4.0067 2.00218 4.00822C1.82738 4.00974 1.66018 4.07985 1.53657 4.20345C1.41297 4.32706 1.34285 4.49427 1.34133 4.66907C1.33981 4.84386 1.40701 5.01227 1.52845 5.138L5.52845 9.138C5.65347 9.26298 5.82301 9.33319 5.99978 9.33319C6.17656 9.33319 6.3461 9.26298 6.47112 9.138L8.66645 6.94267L11.7238 10L10.8618 10.862C10.7686 10.9552 10.7051 11.074 10.6794 11.2033C10.6537 11.3326 10.6669 11.4666 10.7173 11.5884C10.7678 11.7102 10.8532 11.8143 10.9628 11.8876C11.0724 11.9609 11.2013 12 11.3331 12H13.9998L14.0318 11.9993C14.2021 11.9918 14.3629 11.9191 14.4811 11.7962C14.5992 11.6734 14.6656 11.5098 14.6664 11.3393V11.34Z" fill="#B20F19" />
									</svg>
								)}{' '}
								<span className={`${percentChangeTotalAssetUnderMgt > 0 ? 'text-[#0FB23C]' : 'text-[#B20F19]'}`}>{percentChangeTotalAssetUnderMgt}%</span>
								Last month
							</p>
						</div>
					</div>
					<div className="shrink-0 flex items-center gap-[0.5rem] bg-white rounded-[0.75rem] p-[1.5rem]">
						<div className="bg-[#E7E4F9] w-[3.625rem] h-[3.625rem] rounded-full flex items-center justify-center">
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
								<path d="M4.99319 12.9842C4.77597 12.984 4.56458 13.0545 4.39099 13.1851C4.21741 13.3157 4.09107 13.4993 4.03108 13.708C3.97109 13.9168 3.98071 14.1395 4.05849 14.3423C4.13628 14.5451 4.27798 14.7171 4.46219 14.8322L7.15019 17.5202C7.2431 17.613 7.35339 17.6867 7.47476 17.7369C7.59613 17.7871 7.7262 17.813 7.85755 17.8129C7.98889 17.8129 8.11895 17.7869 8.24028 17.7366C8.36161 17.6863 8.47185 17.6126 8.56469 17.5197C8.65754 17.4268 8.73117 17.3165 8.78139 17.1951C8.83162 17.0738 8.85744 16.9437 8.85739 16.8124C8.85735 16.681 8.83143 16.5509 8.78112 16.4296C8.73082 16.3083 8.6571 16.198 8.56419 16.1052L7.44319 14.9852H14.9932C15.2584 14.9852 15.5128 14.8798 15.7003 14.6923C15.8878 14.5048 15.9932 14.2504 15.9932 13.9852C15.9932 13.72 15.8878 13.4656 15.7003 13.2781C15.5128 13.0906 15.2584 12.9852 14.9932 12.9852L4.99319 12.9842ZM19.0072 11.0162C19.2244 11.0164 19.4358 10.9459 19.6094 10.8153C19.783 10.6847 19.9093 10.5011 19.9693 10.2924C20.0293 10.0836 20.0197 9.86096 19.9419 9.65813C19.8641 9.45531 19.7224 9.28333 19.5382 9.1682L16.8502 6.4802C16.6626 6.29269 16.4081 6.18741 16.1428 6.1875C15.8776 6.18759 15.6232 6.29306 15.4357 6.4807C15.2482 6.66834 15.1429 6.92279 15.143 7.18806C15.1431 7.45333 15.2486 7.70769 15.4362 7.8952L16.5572 9.0152H9.00719C8.74198 9.0152 8.48762 9.12056 8.30009 9.3081C8.11255 9.49563 8.00719 9.74999 8.00719 10.0152C8.00719 10.2804 8.11255 10.5348 8.30009 10.7223C8.48762 10.9098 8.74198 11.0152 9.00719 11.0152L19.0072 11.0162Z" fill="#2806F6" />
							</svg>
						</div>
						<div className="flex flex-col gap-[0.25rem] font-poppins">
							<p className="text-[0.875rem] font-semibold text-[#161616]">{totalTransactions}</p>
							<p className="text-[0.75rem] text-[#16161699]">Total Transactions</p>
							<p className="flex items-center gap-[0.62rem] text-[0.75rem] text-[#16161699]">
								{percentageChangeTotalTransactions > 0 ? (
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
										<path fill-rule="evenodd" clip-rule="evenodd" d="M14.6664 4.66V7.33333C14.6664 7.46517 14.6273 7.59403 14.5541 7.70364C14.4808 7.81325 14.3767 7.89867 14.2549 7.94912C14.1331 7.99957 13.9991 8.01277 13.8698 7.98706C13.7405 7.96134 13.6217 7.89787 13.5284 7.80467L12.6664 6.94267L9.13778 10.4713C9.01276 10.5963 8.84323 10.6665 8.66645 10.6665C8.48967 10.6665 8.32014 10.5963 8.19512 10.4713L5.99978 8.276L2.47112 11.8047C2.34538 11.9261 2.17698 11.9933 2.00218 11.9918C1.82738 11.9903 1.66018 11.9202 1.53657 11.7965C1.41297 11.6729 1.34285 11.5057 1.34133 11.3309C1.33981 11.1561 1.40701 10.9877 1.52845 10.862L5.52845 6.862C5.65347 6.73702 5.82301 6.66681 5.99978 6.66681C6.17656 6.66681 6.3461 6.73702 6.47112 6.862L8.66645 9.05733L11.7238 6L10.8618 5.138C10.7686 5.04477 10.7051 4.92599 10.6794 4.79669C10.6537 4.66739 10.6669 4.53336 10.7173 4.41156C10.7678 4.28976 10.8532 4.18565 10.9628 4.1124C11.0724 4.03914 11.2013 4.00003 11.3331 4H13.9998L14.0318 4.00067C14.2021 4.00819 14.3629 4.08092 14.4811 4.20378C14.5992 4.32663 14.6656 4.49022 14.6664 4.66067V4.66Z" fill="#0FB23C" />
									</svg>
								) : (
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
										<path fill-rule="evenodd" clip-rule="evenodd" d="M14.6664 11.34V8.66667C14.6664 8.53483 14.6273 8.40597 14.5541 8.29636C14.4808 8.18675 14.3767 8.10133 14.2549 8.05088C14.1331 8.00043 13.9991 7.98723 13.8698 8.01294C13.7405 8.03866 13.6217 8.10213 13.5284 8.19533L12.6664 9.05733L9.13778 5.52867C9.01276 5.40369 8.84323 5.33348 8.66645 5.33348C8.48967 5.33348 8.32014 5.40369 8.19512 5.52867L5.99978 7.724L2.47112 4.19533C2.34538 4.07389 2.17698 4.0067 2.00218 4.00822C1.82738 4.00974 1.66018 4.07985 1.53657 4.20345C1.41297 4.32706 1.34285 4.49427 1.34133 4.66907C1.33981 4.84386 1.40701 5.01227 1.52845 5.138L5.52845 9.138C5.65347 9.26298 5.82301 9.33319 5.99978 9.33319C6.17656 9.33319 6.3461 9.26298 6.47112 9.138L8.66645 6.94267L11.7238 10L10.8618 10.862C10.7686 10.9552 10.7051 11.074 10.6794 11.2033C10.6537 11.3326 10.6669 11.4666 10.7173 11.5884C10.7678 11.7102 10.8532 11.8143 10.9628 11.8876C11.0724 11.9609 11.2013 12 11.3331 12H13.9998L14.0318 11.9993C14.2021 11.9918 14.3629 11.9191 14.4811 11.7962C14.5992 11.6734 14.6656 11.5098 14.6664 11.3393V11.34Z" fill="#B20F19" />
									</svg>
								)}{' '}
								<span className={`${percentageChangeTotalTransactions > 0 ? 'text-[#0FB23C]' : 'text-[#B20F19]'}`}>{percentageChangeTotalTransactions}%</span>
								Last month
							</p>
						</div>
					</div>
					<div className="shrink-0 flex items-center gap-[0.5rem] bg-white rounded-[0.75rem] p-[1.5rem]">
						<div className="bg-[#F9ECE4] w-[3.625rem] h-[3.625rem] rounded-full flex items-center justify-center">
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
								<path d="M18.7207 3.75084C18.4526 3.77172 18.1965 3.87018 17.9834 4.03422C17.7704 4.19825 17.6098 4.42075 17.5211 4.67457C17.4324 4.92838 17.4195 5.20253 17.484 5.46353C17.5486 5.72454 17.6877 5.96111 17.8844 6.14438C18.6542 6.91268 19.2646 7.82556 19.6804 8.83053C20.0963 9.83551 20.3094 10.9128 20.3075 12.0004C20.3087 13.0879 20.0954 14.165 19.6796 15.1699C19.2638 16.1748 18.6537 17.0877 17.8844 17.8564C17.7507 17.9841 17.6439 18.1372 17.5702 18.3068C17.4965 18.4763 17.4574 18.6589 17.4553 18.8438C17.4532 19.0286 17.488 19.2121 17.5578 19.3833C17.6275 19.5545 17.7308 19.71 17.8616 19.8408C17.9923 19.9715 18.1478 20.0748 18.319 20.1445C18.4902 20.2143 18.6737 20.2491 18.8585 20.247C19.0434 20.2449 19.226 20.2058 19.3956 20.1322C19.5651 20.0585 19.7182 19.9516 19.8459 19.8179C21.9152 17.7424 23.0772 14.9312 23.0772 12.0004C23.0772 9.06958 21.9152 6.25834 19.8459 4.18284C19.7194 4.04906 19.5674 3.94186 19.3989 3.86752C19.2304 3.79318 19.0488 3.7532 18.8647 3.74992C18.8167 3.74742 18.7687 3.74742 18.7207 3.74992V3.75084ZM4.96131 3.77854C4.65446 3.81923 4.37009 3.96158 4.15362 4.18284C2.08435 6.25834 0.922363 9.06958 0.922363 12.0004C0.922363 14.9312 2.08435 17.7424 4.15362 19.8179C4.28131 19.9516 4.43443 20.0585 4.60399 20.1322C4.77355 20.2058 4.95613 20.2449 5.141 20.247C5.32587 20.2491 5.5093 20.2143 5.68051 20.1445C5.85172 20.0748 6.00726 19.9715 6.138 19.8408C6.26873 19.71 6.37201 19.5545 6.44178 19.3833C6.51154 19.2121 6.54639 19.0286 6.54426 18.8438C6.54213 18.6589 6.50308 18.4763 6.42939 18.3068C6.3557 18.1372 6.24886 17.9841 6.11516 17.8564C5.34534 17.0881 4.73497 16.1752 4.31913 15.1702C3.90329 14.1653 3.69019 13.088 3.69208 12.0004C3.6908 10.9129 3.90418 9.83578 4.31998 8.83089C4.73578 7.82599 5.34583 6.91304 6.11516 6.14438C6.32447 5.94111 6.46421 5.67692 6.51446 5.38951C6.5647 5.1021 6.52286 4.80616 6.39492 4.54394C6.26699 4.28172 6.05948 4.06661 5.80203 3.92933C5.54458 3.79204 5.25034 3.73866 4.96131 3.77854ZM8.481 6.83669C8.17741 6.86934 7.89313 7.00142 7.67239 7.21238C7.00251 7.81757 6.4666 8.55616 6.09906 9.38073C5.73153 10.2053 5.5405 11.0976 5.53823 12.0004C5.53823 13.8908 6.34131 15.6096 7.64377 16.7893C7.77833 16.9124 7.93581 17.0078 8.10723 17.07C8.27865 17.1323 8.46065 17.1601 8.64284 17.152C8.82503 17.1439 9.00384 17.1 9.16906 17.0228C9.33428 16.9456 9.48267 16.8366 9.60577 16.7021C9.72887 16.5675 9.82426 16.41 9.8865 16.2386C9.94874 16.0672 9.9766 15.8852 9.9685 15.703C9.9604 15.5208 9.9165 15.342 9.83929 15.1768C9.76209 15.0116 9.6531 14.8632 9.51854 14.7401C9.13533 14.3943 8.82939 13.9715 8.6207 13.4994C8.41201 13.0273 8.30528 12.5165 8.30747 12.0004C8.30555 11.484 8.4125 10.9731 8.62134 10.5009C8.83017 10.0287 9.1362 9.60576 9.51947 9.25977C9.74068 9.06732 9.89509 8.80962 9.96045 8.52379C10.0258 8.23796 9.99875 7.93876 9.88316 7.6693C9.76758 7.39983 9.56943 7.17402 9.31728 7.02439C9.06513 6.87476 8.7729 6.80903 8.481 6.83669ZM15.3173 6.83669C15.0427 6.85183 14.7788 6.9484 14.5593 7.11409C14.3398 7.27978 14.1746 7.50708 14.0848 7.76702C13.995 8.02696 13.9846 8.30775 14.055 8.57361C14.1254 8.83946 14.2734 9.07833 14.4801 9.25977C14.8636 9.60558 15.1698 10.0284 15.3786 10.5007C15.5875 10.973 15.6943 11.484 15.6921 12.0004C15.694 12.5167 15.587 13.0277 15.3782 13.4999C15.1694 13.9721 14.8633 14.395 14.4801 14.741C14.3258 14.8562 14.1973 15.0024 14.1026 15.1701C14.008 15.3378 13.9495 15.5234 13.9306 15.715C13.9118 15.9067 13.9332 16.1001 13.9934 16.2831C14.0535 16.466 14.1512 16.6343 14.2801 16.7774C14.409 16.9204 14.5664 17.035 14.7421 17.1138C14.9178 17.1925 15.108 17.2338 15.3005 17.235C15.4931 17.2361 15.6838 17.197 15.8604 17.1203C16.037 17.0436 16.1957 16.9308 16.3262 16.7893C16.9964 16.1841 17.5326 15.4454 17.9002 14.6206C18.2679 13.7959 18.4591 12.9034 18.4613 12.0004C18.4647 11.0993 18.2791 10.2075 17.9164 9.38261C17.5538 8.55772 17.0221 7.81808 16.3558 7.21146C16.2176 7.08111 16.0542 6.98057 15.8755 6.9161C15.6969 6.85162 15.5069 6.82459 15.3173 6.83669ZM11.9998 10.3278C11.669 10.3279 11.3457 10.4262 11.0708 10.6101C10.7958 10.794 10.5816 11.0553 10.4551 11.3609C10.3287 11.6666 10.2957 12.0029 10.3603 12.3273C10.425 12.6517 10.5843 12.9496 10.8183 13.1834C11.0523 13.4173 11.3503 13.5765 11.6747 13.6409C11.9992 13.7054 12.3354 13.6722 12.641 13.5456C12.9466 13.419 13.2077 13.2046 13.3915 12.9295C13.5752 12.6545 13.6733 12.3312 13.6733 12.0004C13.6737 11.7805 13.6306 11.5627 13.5467 11.3595C13.4627 11.1563 13.3394 10.9717 13.184 10.8162C13.0285 10.6607 12.8438 10.5375 12.6406 10.4535C12.4374 10.3695 12.2196 10.3274 11.9998 10.3278Z" fill="#F45D00" />
							</svg>
						</div>
						<div className="flex flex-col gap-[0.25rem] font-poppins">
							<p className="text-[0.875rem] font-semibold text-[#161616]">{averageDailyActiveUsers}</p>
							<p className="text-[0.75rem] text-[#16161699]">Average Daily Active Users</p>
							<p className="flex items-center gap-[0.62rem] text-[0.75rem] text-[#16161699]">
								{percentageChangeDailyActiveUsers > 0 ? (
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
										<path fill-rule="evenodd" clip-rule="evenodd" d="M14.6664 4.66V7.33333C14.6664 7.46517 14.6273 7.59403 14.5541 7.70364C14.4808 7.81325 14.3767 7.89867 14.2549 7.94912C14.1331 7.99957 13.9991 8.01277 13.8698 7.98706C13.7405 7.96134 13.6217 7.89787 13.5284 7.80467L12.6664 6.94267L9.13778 10.4713C9.01276 10.5963 8.84323 10.6665 8.66645 10.6665C8.48967 10.6665 8.32014 10.5963 8.19512 10.4713L5.99978 8.276L2.47112 11.8047C2.34538 11.9261 2.17698 11.9933 2.00218 11.9918C1.82738 11.9903 1.66018 11.9202 1.53657 11.7965C1.41297 11.6729 1.34285 11.5057 1.34133 11.3309C1.33981 11.1561 1.40701 10.9877 1.52845 10.862L5.52845 6.862C5.65347 6.73702 5.82301 6.66681 5.99978 6.66681C6.17656 6.66681 6.3461 6.73702 6.47112 6.862L8.66645 9.05733L11.7238 6L10.8618 5.138C10.7686 5.04477 10.7051 4.92599 10.6794 4.79669C10.6537 4.66739 10.6669 4.53336 10.7173 4.41156C10.7678 4.28976 10.8532 4.18565 10.9628 4.1124C11.0724 4.03914 11.2013 4.00003 11.3331 4H13.9998L14.0318 4.00067C14.2021 4.00819 14.3629 4.08092 14.4811 4.20378C14.5992 4.32663 14.6656 4.49022 14.6664 4.66067V4.66Z" fill="#0FB23C" />
									</svg>
								) : (
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
										<path fill-rule="evenodd" clip-rule="evenodd" d="M14.6664 11.34V8.66667C14.6664 8.53483 14.6273 8.40597 14.5541 8.29636C14.4808 8.18675 14.3767 8.10133 14.2549 8.05088C14.1331 8.00043 13.9991 7.98723 13.8698 8.01294C13.7405 8.03866 13.6217 8.10213 13.5284 8.19533L12.6664 9.05733L9.13778 5.52867C9.01276 5.40369 8.84323 5.33348 8.66645 5.33348C8.48967 5.33348 8.32014 5.40369 8.19512 5.52867L5.99978 7.724L2.47112 4.19533C2.34538 4.07389 2.17698 4.0067 2.00218 4.00822C1.82738 4.00974 1.66018 4.07985 1.53657 4.20345C1.41297 4.32706 1.34285 4.49427 1.34133 4.66907C1.33981 4.84386 1.40701 5.01227 1.52845 5.138L5.52845 9.138C5.65347 9.26298 5.82301 9.33319 5.99978 9.33319C6.17656 9.33319 6.3461 9.26298 6.47112 9.138L8.66645 6.94267L11.7238 10L10.8618 10.862C10.7686 10.9552 10.7051 11.074 10.6794 11.2033C10.6537 11.3326 10.6669 11.4666 10.7173 11.5884C10.7678 11.7102 10.8532 11.8143 10.9628 11.8876C11.0724 11.9609 11.2013 12 11.3331 12H13.9998L14.0318 11.9993C14.2021 11.9918 14.3629 11.9191 14.4811 11.7962C14.5992 11.6734 14.6656 11.5098 14.6664 11.3393V11.34Z" fill="#B20F19" />
									</svg>
								)}
								<span className={`${percentageChangeDailyActiveUsers > 0 ? 'text-[#0FB23C]' : 'text-[#B20F19]'}`}>{percentageChangeDailyActiveUsers}%</span>
								Last month
							</p>
						</div>
					</div>
				</div>
				<div className="flex flex-col-reverse lg:flex-row w-[100%] lg:px-[2rem] px-[1rem] gap-[2rem] lg:mt-[8rem] mt-[4.5rem]">
					<div className="lg:w-[70%] w-[100%]">
						<div className="lg:px-[1.5rem] px-[1rem] bg-white rounded-[0.75rem] pb-[1.94rem] shadow-[0_2px_16px_0_rgba(128,128,128,0.18)]">
							<div className="flex flex-col">
								<div className="flex flex-col lg:flex-row items-center lg:gap-10">
									<div>
										<Menu>
											{({ open }) => (
												<>
													<Menu.Button>
														<div className="whitespace-nowrap flex w-[100%] mt-[1.5rem] mb-[0.62rem] gap-[0.25rem] items-center px-[0.75rem] py-[0.5rem] font-poppins text-[0.875rem] text-[hsl(0,0%,9%)] rounded-[0.75rem] bg-[#0FB23C1A] max-w-max border border-[#0FB23C]">
															{lineGraphDaysFilter === 'total_users_data' ? lineGraphFilterItems.filter(item => item.value === lineGraphFilter1)[0].label : lineGraphDaysFilter === 'last_week_data' || lineGraphDaysFilter === 'last_month_data' ? lineGraphFilterItems.filter(item => item.value === lineGraphFilter1)[0].labelSecond : lineGraphDaysFilter === 'last_year_data' ? lineGraphFilterItems.filter(item => item.value === lineGraphFilter1)[0].labelForth : lineGraphFilterItems.filter(item => item.value === lineGraphFilter1)[0].labelThird}{' '}
															<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
																<g clip-path="url(#clip0_1637_4054)">
																	<path fill-rule="evenodd" clip-rule="evenodd" d="M8.47124 10.4712C8.34622 10.5962 8.17668 10.6664 7.9999 10.6664C7.82313 10.6664 7.65359 10.5962 7.52857 10.4712L3.75724 6.6999C3.69356 6.63841 3.64277 6.56484 3.60784 6.48351C3.5729 6.40217 3.55451 6.31469 3.55374 6.22617C3.55297 6.13765 3.56983 6.04986 3.60336 5.96793C3.63688 5.886 3.68638 5.81157 3.74897 5.74897C3.81157 5.68638 3.886 5.63688 3.96793 5.60336C4.04986 5.56983 4.13765 5.55297 4.22617 5.55374C4.31469 5.55451 4.40217 5.5729 4.48351 5.60784C4.56484 5.64277 4.63841 5.69356 4.6999 5.75724L7.9999 9.05724L11.2999 5.75724C11.4256 5.6358 11.594 5.5686 11.7688 5.57012C11.9436 5.57164 12.1108 5.64175 12.2344 5.76536C12.3581 5.88896 12.4282 6.05617 12.4297 6.23097C12.4312 6.40577 12.364 6.57417 12.2426 6.6999L8.47124 10.4712Z" fill="#161616" />
																</g>
																<defs>
																	<clipPath id="clip0_1637_4054">
																		<rect width="16" height="16" fill="white" />
																	</clipPath>
																</defs>
															</svg>
														</div>
													</Menu.Button>
													<Transition as={Fragment} enter="transition ease-out duration-100" enterFrom="transform opacity-0 scale-95" enterTo="transform opacity-100 scale-100" leave="transition ease-in duration-75" leaveFrom="transform opacity-100 scale-100" leaveTo="transform opacity-0 scale-95">
														<Menu.Items className="absolute shadow-[0_4px_16px_2px_rgba(1,1,1,0.15)] lg:w-[15.2rem] w-[70%] z-10 lg:mt-[1rem] mt-[0.1rem] lg:mr-[5rem] origin-top-right divide-y divide-gray-300 rounded-[0.75rem] bg-[#F1F1F1] ring-1 ring-black ring-opacity-5 focus:outline-none flex flex-col">
															{lineGraphFilterItems
																.filter(item => item.value !== lineGraphFilter2)
																.map(it => (
																	<Menu.Item key={it.value}>
																		{({ active }) => (
																			<button
																				onClick={e => {
																					// e.preventDefault()
																					setLineGraphFilter1(it.value);
																					// console.log("clicked")
																				}}
																				className={`group gap-[1rem] justify-start flex w-full items-center font-poppins rounded-t-[0.75rem] py-[0.5rem] px-[0.75rem] text-[0.875rem]`}
																			>
																				<p className="text-[#161616]">{lineGraphDaysFilter === 'total_users_data' ? it.label : lineGraphDaysFilter === 'last_week_data' || lineGraphDaysFilter === 'last_month_data' ? it.labelSecond : lineGraphDaysFilter === 'last_year_data' ? it.labelForth : it.labelThird}</p>
																			</button>
																		)}
																	</Menu.Item>
																))}
														</Menu.Items>
													</Transition>
												</>
											)}
										</Menu>
									</div>
									<div>
										<Menu>
											{({ open }) => (
												<>
													<Menu.Button>
														<div className="whitespace-nowrap flex w-[100%] mt-[1.5rem] mb-[0.62rem] gap-[0.25rem] items-center px-[0.75rem] py-[0.5rem] font-poppins text-[0.875rem] text-[#161616] rounded-[0.75rem] bg-[#E7A6001A] max-w-max border border-[#E7A600]">
															{lineGraphDaysFilter === 'total_users_data' ? lineGraphFilterItems.filter(item => item.value === lineGraphFilter2)[0].label : lineGraphDaysFilter === 'last_week_data' || lineGraphDaysFilter === 'last_month_data' ? lineGraphFilterItems.filter(item => item.value === lineGraphFilter2)[0].labelSecond : lineGraphDaysFilter === 'last_year_data' ? lineGraphFilterItems.filter(item => item.value === lineGraphFilter2)[0].labelForth : lineGraphFilterItems.filter(item => item.value === lineGraphFilter2)[0].labelThird}{' '}
															<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
																<g clip-path="url(#clip0_1637_4054)">
																	<path fill-rule="evenodd" clip-rule="evenodd" d="M8.47124 10.4712C8.34622 10.5962 8.17668 10.6664 7.9999 10.6664C7.82313 10.6664 7.65359 10.5962 7.52857 10.4712L3.75724 6.6999C3.69356 6.63841 3.64277 6.56484 3.60784 6.48351C3.5729 6.40217 3.55451 6.31469 3.55374 6.22617C3.55297 6.13765 3.56983 6.04986 3.60336 5.96793C3.63688 5.886 3.68638 5.81157 3.74897 5.74897C3.81157 5.68638 3.886 5.63688 3.96793 5.60336C4.04986 5.56983 4.13765 5.55297 4.22617 5.55374C4.31469 5.55451 4.40217 5.5729 4.48351 5.60784C4.56484 5.64277 4.63841 5.69356 4.6999 5.75724L7.9999 9.05724L11.2999 5.75724C11.4256 5.6358 11.594 5.5686 11.7688 5.57012C11.9436 5.57164 12.1108 5.64175 12.2344 5.76536C12.3581 5.88896 12.4282 6.05617 12.4297 6.23097C12.4312 6.40577 12.364 6.57417 12.2426 6.6999L8.47124 10.4712Z" fill="#161616" />
																</g>
																<defs>
																	<clipPath id="clip0_1637_4054">
																		<rect width="16" height="16" fill="white" />
																	</clipPath>
																</defs>
															</svg>
														</div>
													</Menu.Button>
													<Transition as={Fragment} enter="transition ease-out duration-100" enterFrom="transform opacity-0 scale-95" enterTo="transform opacity-100 scale-100" leave="transition ease-in duration-75" leaveFrom="transform opacity-100 scale-100" leaveTo="transform opacity-0 scale-95">
														<Menu.Items className="absolute shadow-[0_4px_16px_2px_rgba(1,1,1,0.15)] lg:w-[15.2rem] w-[70%] z-10 lg:mt-[1rem] mt-[0.1rem] lg:mr-[5rem] origin-top-right divide-y divide-gray-300 rounded-[0.75rem] bg-[#F1F1F1] ring-1 ring-black ring-opacity-5 focus:outline-none flex flex-col">
															{lineGraphFilterItems
																.filter(item => item.value !== lineGraphFilter1)
																.map(it => (
																	<Menu.Item key={it.value}>
																		{({ active }) => (
																			<button
																				onClick={e => {
																					// e.preventDefault()
																					setLineGraphFilter2(it.value);
																					// console.log("clicked")
																				}}
																				className={`group gap-[1rem] justify-start flex w-full items-center font-poppins rounded-t-[0.75rem] py-[0.5rem] px-[0.75rem] text-[0.875rem]`}
																			>
																				<p className="text-[#161616]">{lineGraphDaysFilter === 'total_users_data' ? it.label : lineGraphDaysFilter === 'last_week_data' || lineGraphDaysFilter === 'last_month_data' ? it.labelSecond : lineGraphDaysFilter === 'last_year_data' ? it.labelForth : it.labelThird}</p>
																			</button>
																		)}
																	</Menu.Item>
																))}
														</Menu.Items>
													</Transition>
												</>
											)}
										</Menu>
									</div>
								</div>
								<div className="flex items-center justify-center lg:justify-end w-[100%] gap-[2rem] ml-auto mr-[1.5rem] mb-[0.38rem]">
									{lineGraphData.length > 0 && (
										<p className="font-poppins text-[0.75rem] text-[#16161699]">
											{ConvertData(lineGraphData[0].date)} - {ConvertData(lineGraphData[lineGraphData.length - 1].date)}
										</p>
									)}
									<div className="flex items-center font-poppins text-[0.875rem]">
										<Menu>
											{({ open }) => (
												<>
													<Menu.Button>
														<div className="flex items-center font-poppins text-[0.875rem]">
															{lineGraphDaysFilterItems.filter(item => item.value === lineGraphDaysFilter)[0].label}{' '}
															<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
																<g clip-path="url(#clip0_2703_71)">
																	<path fill-rule="evenodd" clip-rule="evenodd" d="M8.47124 10.4712C8.34622 10.5962 8.17668 10.6664 7.9999 10.6664C7.82313 10.6664 7.65359 10.5962 7.52857 10.4712L3.75724 6.6999C3.69356 6.63841 3.64277 6.56484 3.60784 6.48351C3.5729 6.40217 3.55451 6.31469 3.55374 6.22617C3.55297 6.13765 3.56983 6.04986 3.60336 5.96793C3.63688 5.886 3.68638 5.81157 3.74897 5.74897C3.81157 5.68638 3.886 5.63688 3.96793 5.60336C4.04986 5.56983 4.13765 5.55297 4.22617 5.55374C4.31469 5.55451 4.40217 5.5729 4.48351 5.60784C4.56484 5.64277 4.63841 5.69356 4.6999 5.75724L7.9999 9.05724L11.2999 5.75724C11.4256 5.6358 11.594 5.5686 11.7688 5.57012C11.9436 5.57164 12.1108 5.64175 12.2344 5.76536C12.3581 5.88896 12.4282 6.05617 12.4297 6.23097C12.4312 6.40577 12.364 6.57417 12.2426 6.6999L8.47124 10.4712Z" fill="#161616" />
																</g>
																<defs>
																	<clipPath id="clip0_2703_71">
																		<rect width="16" height="16" fill="white" />
																	</clipPath>
																</defs>
															</svg>
														</div>
													</Menu.Button>
													<Transition as={Fragment} enter="transition ease-out duration-100" enterFrom="transform opacity-0 scale-95" enterTo="transform opacity-100 scale-100" leave="transition ease-in duration-75" leaveFrom="transform opacity-100 scale-100" leaveTo="transform opacity-0 scale-95">
														<Menu.Items className="absolute shadow-[0_4px_16px_2px_rgba(1,1,1,0.15)] lg:w-[8.2rem] w-[40%] z-10 lg:mt-[12rem] mt-[11rem] origin-top-right divide-y divide-gray-300 rounded-[0.75rem] bg-[#F1F1F1] ring-1 ring-black ring-opacity-5 focus:outline-none flex flex-col">
															{lineGraphDaysFilterItems
																.filter(item => item.value !== lineGraphDaysFilter)
																.map(it => (
																	<Menu.Item key={it.value}>
																		{({ active }) => (
																			<button
																				onClick={e => {
																					// e.preventDefault()
																					setLineGraphDaysFilter(it.value);
																					// console.log("clicked")
																				}}
																				className={`group gap-[1rem] justify-start flex w-full items-center font-poppins rounded-t-[0.75rem] py-[0.5rem] px-[0.75rem] text-[0.875rem]`}
																			>
																				<p className="text-[#161616]">{it.label}</p>
																			</button>
																		)}
																	</Menu.Item>
																))}
														</Menu.Items>
													</Transition>
												</>
											)}
										</Menu>
									</div>
									{/* <div className='flex items-center font-poppins text-[0.875rem]'>Daily <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2703_71)">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.47124 10.4712C8.34622 10.5962 8.17668 10.6664 7.9999 10.6664C7.82313 10.6664 7.65359 10.5962 7.52857 10.4712L3.75724 6.6999C3.69356 6.63841 3.64277 6.56484 3.60784 6.48351C3.5729 6.40217 3.55451 6.31469 3.55374 6.22617C3.55297 6.13765 3.56983 6.04986 3.60336 5.96793C3.63688 5.886 3.68638 5.81157 3.74897 5.74897C3.81157 5.68638 3.886 5.63688 3.96793 5.60336C4.04986 5.56983 4.13765 5.55297 4.22617 5.55374C4.31469 5.55451 4.40217 5.5729 4.48351 5.60784C4.56484 5.64277 4.63841 5.69356 4.6999 5.75724L7.9999 9.05724L11.2999 5.75724C11.4256 5.6358 11.594 5.5686 11.7688 5.57012C11.9436 5.57164 12.1108 5.64175 12.2344 5.76536C12.3581 5.88896 12.4282 6.05617 12.4297 6.23097C12.4312 6.40577 12.364 6.57417 12.2426 6.6999L8.47124 10.4712Z" fill="#161616" />
                    </g>
                    <defs>
                      <clipPath id="clip0_2703_71">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  </div> */}
								</div>
							</div>
							{lineGraphData.length > 0 && (
								<MainLineChart
									data={lineGraphData?.map(dat => ({
										name: dat['date'],
										uv: dat[lineGraphFilter2],
										pv: dat[lineGraphFilter1]
									}))}
									name={lineGraphDaysFilterItems.filter(item => item.value === lineGraphDaysFilter)[0].label}
								/>
							)}
						</div>
						<div className="w-[100%] block lg:hidden p-[1.5rem] mt-10 bg-white rounded-[0.75rem] shadow-[0_2px_16px_0_rgba(128,128,128,0.18)]">
							<div className="flex items-start justify-between">
								<p className="font-poppins font-semibold text-[0.875rem] text-[#161616]">Order Book</p>
								<div className="flex items-center gap-[0.25rem] px-[0.75rem] py-[0.5rem] bg-[#F1F1F1] rounded-[0.75rem]">
									<p>DANGCEM/NGN</p>
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
										<g clip-path="url(#clip0_1987_6961)">
											<path fill-rule="evenodd" clip-rule="evenodd" d="M8.47124 10.4712C8.34622 10.5962 8.17668 10.6664 7.9999 10.6664C7.82313 10.6664 7.65359 10.5962 7.52857 10.4712L3.75724 6.6999C3.69356 6.63841 3.64277 6.56484 3.60784 6.48351C3.5729 6.40217 3.55451 6.31469 3.55374 6.22617C3.55297 6.13765 3.56983 6.04986 3.60336 5.96793C3.63688 5.886 3.68638 5.81157 3.74897 5.74897C3.81157 5.68638 3.886 5.63688 3.96793 5.60336C4.04986 5.56983 4.13765 5.55297 4.22617 5.55374C4.31469 5.55451 4.40217 5.5729 4.48351 5.60784C4.56484 5.64277 4.63841 5.69356 4.6999 5.75724L7.9999 9.05724L11.2999 5.75724C11.4256 5.6358 11.594 5.5686 11.7688 5.57012C11.9436 5.57164 12.1108 5.64175 12.2344 5.76536C12.3581 5.88896 12.4282 6.05617 12.4297 6.23097C12.4312 6.40577 12.364 6.57417 12.2426 6.6999L8.47124 10.4712Z" fill="#161616" />
										</g>
										<defs>
											<clipPath id="clip0_1987_6961">
												<rect width="16" height="16" fill="white" />
											</clipPath>
										</defs>
									</svg>
								</div>
							</div>
							<div className="flex justify-between items-center my-[1rem] pb-[1rem] border-b">
								<p className="flex flex-col font-poppins text-[#161616] text-[0.75rem]">
									Price <span>(NGN)</span>
								</p>
								<p className="flex flex-col font-poppins text-[#161616] text-[0.75rem]">
									Amount <span>DANGCEM</span>
								</p>
							</div>
							<div className="w-[100%]">
								{orderBookData.sells
									.sort((a, b) => parseInt(b.amount, 10) - parseInt(a.amount, 10))
									.map(sell => {
										let percent = Math.round(Number((sell.amount * 100) / totalSellAmount));
										console.log(percent);

										return (
											<div style={{ backgroundSize: `${percent}% 100%` }} className='flex font-poppins text-[0.75rem] text-[#161616] items-center p-[0.5rem] w-[100%] justify-between bg-no-repeat bg-[url("https://res.cloudinary.com/ddlupbcws/image/upload/v1702032967/bg_nlqn2z.webp")] bg-right'>
												<p>{sell.price}</p>
												<p>{sell.amount}</p>
											</div>
										);
									})}

								<p className="font-poppins text-[0.875rem] text-[#0FB23C] font-semibold text-center my-[0.5rem]">{orderBookData.total}</p>

								{orderBookData.buys
									.sort((a, b) => parseInt(a.amount, 10) - parseInt(b.amount, 10))
									.map(buy => {
										let percent = Math.round(Number((buy.amount * 100) / totalSellAmount));
										console.log(percent);

										return (
											<div style={{ backgroundSize: `${percent}% 100%` }} className='flex font-poppins text-[0.75rem] text-[#161616] items-center p-[0.5rem] w-[100%] justify-between bg-no-repeat bg-[url("https://res.cloudinary.com/ddlupbcws/image/upload/v1702042518/bg_nhz4om.webp")] bg-right'>
												<p>{buy.price}</p>
												<p>{buy.amount}</p>
											</div>
										);
									})}
							</div>
						</div>
						<div className="lg:h-[30rem] h-[23rem] pt-[1.5rem] mt-10 bg-white rounded-[0.75rem] pb-[1.94rem] px-[1.5rem] shadow-[0_2px_16px_0_rgba(128,128,128,0.18)]">
							<p className="lg:mb-[1.5rem] font-poppins text-[0.875rem] font-semibold text-[#161616]">Stocks with most open positions</p>
							<MainTreeMapChart data={mostTradedStock} />
						</div>
						<div className="bg-white block lg:hidden mt-10 p-[1.5rem] rounded-[0.75rem] shadow-[0_2px_16px_0_rgba(128,128,128,0.18)]">
							<h1 className="font-poppins text-[0.875rem] font-semibold text-[#161616] text-center mb-[1rem]">Most Traded Stocks</h1>
							<MostTradedStockTable data={mostTradedStock} />
						</div>
						<div className="lg:px-[1.5rem] px-[1rem] pt-[1.5rem] mt-10 bg-white rounded-[0.75rem] pb-[1.94rem] shadow-[0_2px_16px_0_rgba(128,128,128,0.18)]">
							<p className="mb-[1.5rem] font-poppins text-[0.875rem] font-semibold text-[#161616]">Daily trading volume</p>
							<div className="flex flex-col gap-3 lg:flex-row items-center justify-between mb-5">
								<div>
									<Menu>
										{({ open }) => (
											<>
												<Menu.Button>
													<div className="flex items-center gap-[0.25rem] px-[0.75rem] py-[0.5rem] bg-[#F1F1F1] rounded-[0.75rem]">
														<p>{barChartFilter}</p>
														<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
															<g clip-path="url(#clip0_1987_6961)">
																<path fill-rule="evenodd" clip-rule="evenodd" d="M8.47124 10.4712C8.34622 10.5962 8.17668 10.6664 7.9999 10.6664C7.82313 10.6664 7.65359 10.5962 7.52857 10.4712L3.75724 6.6999C3.69356 6.63841 3.64277 6.56484 3.60784 6.48351C3.5729 6.40217 3.55451 6.31469 3.55374 6.22617C3.55297 6.13765 3.56983 6.04986 3.60336 5.96793C3.63688 5.886 3.68638 5.81157 3.74897 5.74897C3.81157 5.68638 3.886 5.63688 3.96793 5.60336C4.04986 5.56983 4.13765 5.55297 4.22617 5.55374C4.31469 5.55451 4.40217 5.5729 4.48351 5.60784C4.56484 5.64277 4.63841 5.69356 4.6999 5.75724L7.9999 9.05724L11.2999 5.75724C11.4256 5.6358 11.594 5.5686 11.7688 5.57012C11.9436 5.57164 12.1108 5.64175 12.2344 5.76536C12.3581 5.88896 12.4282 6.05617 12.4297 6.23097C12.4312 6.40577 12.364 6.57417 12.2426 6.6999L8.47124 10.4712Z" fill="#161616" />
															</g>
															<defs>
																<clipPath id="clip0_1987_6961">
																	<rect width="16" height="16" fill="white" />
																</clipPath>
															</defs>
														</svg>
													</div>
												</Menu.Button>
												<Transition as={Fragment} enter="transition ease-out duration-100" enterFrom="transform opacity-0 scale-95" enterTo="transform opacity-100 scale-100" leave="transition ease-in duration-75" leaveFrom="transform opacity-100 scale-100" leaveTo="transform opacity-0 scale-95">
													<Menu.Items className="absolute shadow-[0_4px_16px_2px_rgba(1,1,1,0.15)] lg:w-[10.2rem] w-[80%] z-10 lg:mt-[1rem] mt-[1rem] lg:mr-[5rem] origin-top-right divide-y divide-gray-300 rounded-[0.75rem] bg-[#F1F1F1] ring-1 ring-black ring-opacity-5 focus:outline-none flex flex-col">
														{tradingVolumeKeys.map(key => (
															<Menu.Item key={key}>
																{({ active }) => (
																	<button
																		onClick={e => {
																			// e.preventDefault()
																			// console.log("clicked")
																			setBarChartFilter(key);
																		}}
																		className={`group gap-[1rem] justify-start flex w-full items-center font-poppins rounded-t-[0.75rem] py-[0.5rem] px-[0.75rem] text-[0.875rem]`}
																	>
																		<p className="text-[#16161699]">{key}</p>
																	</button>
																)}
															</Menu.Item>
														))}
													</Menu.Items>
												</Transition>
											</>
										)}
									</Menu>
								</div>

								<div className="flex items-center gap-[0.25rem] px-[0.75rem] py-[0.5rem] bg-[#F1F1F1] rounded-[0.75rem]">
									{/* <p>21 Dec - 27 Dec</p> */}
									<DatePicker selected={startDate} onChange={onChange} startDate={startDate} endDate={endDate} selectsRange closeOnScroll={true} style={{ background: '#F1F1F1' }} customInput={<ExampleCustomInput />} open={openDatePicker} />
									<svg className="cursor-pointer" onClick={() => setOpenDatePicker(!openDatePicker)} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
										<g clip-path="url(#clip0_2703_2742)">
											<path d="M13 2.5H3C2.17157 2.5 1.5 3.17157 1.5 4V13C1.5 13.8284 2.17157 14.5 3 14.5H13C13.8284 14.5 14.5 13.8284 14.5 13V4C14.5 3.17157 13.8284 2.5 13 2.5Z" stroke="#161616" stroke-width="1.5" stroke-linejoin="round" />
											<path d="M9.25 8C9.66421 8 10 7.66421 10 7.25C10 6.83579 9.66421 6.5 9.25 6.5C8.83579 6.5 8.5 6.83579 8.5 7.25C8.5 7.66421 8.83579 8 9.25 8Z" fill="#161616" />
											<path d="M11.75 8C12.1642 8 12.5 7.66421 12.5 7.25C12.5 6.83579 12.1642 6.5 11.75 6.5C11.3358 6.5 11 6.83579 11 7.25C11 7.66421 11.3358 8 11.75 8Z" fill="#161616" />
											<path d="M9.25 10.5C9.66421 10.5 10 10.1642 10 9.75C10 9.33579 9.66421 9 9.25 9C8.83579 9 8.5 9.33579 8.5 9.75C8.5 10.1642 8.83579 10.5 9.25 10.5Z" fill="#161616" />
											<path d="M11.75 10.5C12.1642 10.5 12.5 10.1642 12.5 9.75C12.5 9.33579 12.1642 9 11.75 9C11.3358 9 11 9.33579 11 9.75C11 10.1642 11.3358 10.5 11.75 10.5Z" fill="#161616" />
											<path d="M4.25 10.5C4.66421 10.5 5 10.1642 5 9.75C5 9.33579 4.66421 9 4.25 9C3.83579 9 3.5 9.33579 3.5 9.75C3.5 10.1642 3.83579 10.5 4.25 10.5Z" fill="#161616" />
											<path d="M6.75 10.5C7.16421 10.5 7.5 10.1642 7.5 9.75C7.5 9.33579 7.16421 9 6.75 9C6.33579 9 6 9.33579 6 9.75C6 10.1642 6.33579 10.5 6.75 10.5Z" fill="#161616" />
											<path d="M4.25 13C4.66421 13 5 12.6642 5 12.25C5 11.8358 4.66421 11.5 4.25 11.5C3.83579 11.5 3.5 11.8358 3.5 12.25C3.5 12.6642 3.83579 13 4.25 13Z" fill="#161616" />
											<path d="M6.75 13C7.16421 13 7.5 12.6642 7.5 12.25C7.5 11.8358 7.16421 11.5 6.75 11.5C6.33579 11.5 6 11.8358 6 12.25C6 12.6642 6.33579 13 6.75 13Z" fill="#161616" />
											<path d="M9.25 13C9.66421 13 10 12.6642 10 12.25C10 11.8358 9.66421 11.5 9.25 11.5C8.83579 11.5 8.5 11.8358 8.5 12.25C8.5 12.6642 8.83579 13 9.25 13Z" fill="#161616" />
											<path d="M4 1.5V2.5M12 1.5V2.5" stroke="#161616" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
											<path d="M14.5 5H1.5" stroke="#161616" stroke-width="1.5" stroke-linejoin="round" />
										</g>
										<defs>
											<clipPath id="clip0_2703_2742">
												<rect width="16" height="16" fill="white" />
											</clipPath>
										</defs>
									</svg>
								</div>
							</div>
							<MainBarChart
								data={volumeData[barChartFilter]
									?.filter(dat => dat.date >= firstDate && dat.date <= secondDate)
									.sort((a, b) => new Date(a.date) - new Date(b.date))
									.map(dat => ({ name: dat.date, amt: dat.volume }))}
							/>
						</div>
						<div className="lg:px-[1.5rem] px-[1rem] h-[500px] pt-[1.5rem] mt-10 bg-white rounded-[0.75rem] pb-[1.94rem] shadow-[0_2px_16px_0_rgba(128,128,128,0.18)]">
							<p className="lg:mb-[1.5rem] font-poppins text-[0.875rem] font-semibold text-[#161616]">Active Users Chart</p>
							<MainColumnChart />
						</div>
					</div>

					<div className="lg:w-[30%] w-[100%]">
						<div className="w-[100%] hidden lg:block p-[1.5rem] bg-white rounded-[0.75rem] shadow-[0_2px_16px_0_rgba(128,128,128,0.18)]">
							<div className="flex items-start justify-between">
								<p className="font-poppins font-semibold text-[0.875rem] text-[#161616]">Order Book</p>
								<div className="flex items-center gap-[0.25rem] px-[0.75rem] py-[0.5rem] bg-[#F1F1F1] rounded-[0.75rem]">
									<p>DANGCEM/NGN</p>
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
										<g clip-path="url(#clip0_1987_6961)">
											<path fill-rule="evenodd" clip-rule="evenodd" d="M8.47124 10.4712C8.34622 10.5962 8.17668 10.6664 7.9999 10.6664C7.82313 10.6664 7.65359 10.5962 7.52857 10.4712L3.75724 6.6999C3.69356 6.63841 3.64277 6.56484 3.60784 6.48351C3.5729 6.40217 3.55451 6.31469 3.55374 6.22617C3.55297 6.13765 3.56983 6.04986 3.60336 5.96793C3.63688 5.886 3.68638 5.81157 3.74897 5.74897C3.81157 5.68638 3.886 5.63688 3.96793 5.60336C4.04986 5.56983 4.13765 5.55297 4.22617 5.55374C4.31469 5.55451 4.40217 5.5729 4.48351 5.60784C4.56484 5.64277 4.63841 5.69356 4.6999 5.75724L7.9999 9.05724L11.2999 5.75724C11.4256 5.6358 11.594 5.5686 11.7688 5.57012C11.9436 5.57164 12.1108 5.64175 12.2344 5.76536C12.3581 5.88896 12.4282 6.05617 12.4297 6.23097C12.4312 6.40577 12.364 6.57417 12.2426 6.6999L8.47124 10.4712Z" fill="#161616" />
										</g>
										<defs>
											<clipPath id="clip0_1987_6961">
												<rect width="16" height="16" fill="white" />
											</clipPath>
										</defs>
									</svg>
								</div>
							</div>
							<div className="flex justify-between items-center my-[1rem] pb-[1rem] border-b">
								<p className="flex flex-col font-poppins text-[#161616] text-[0.75rem]">
									Price <span>(NGN)</span>
								</p>
								<p className="flex flex-col font-poppins text-[#161616] text-[0.75rem]">
									Amount <span>DANGCEM</span>
								</p>
							</div>
							<div className="w-[100%]">
								{orderBookData.sells
									.sort((a, b) => parseInt(b.amount, 10) - parseInt(a.amount, 10))
									.map(sell => {
										let percent = Math.round(Number((sell.amount * 100) / totalSellAmount));
										console.log(percent);

										return (
											<div style={{ backgroundSize: `${percent}% 100%` }} className='flex font-poppins text-[0.75rem] text-[#161616] items-center p-[0.5rem] w-[100%] justify-between bg-no-repeat bg-[url("https://res.cloudinary.com/ddlupbcws/image/upload/v1702032967/bg_nlqn2z.webp")] bg-right'>
												<p>{sell.price}</p>
												<p>{sell.amount}</p>
											</div>
										);
									})}

								<p className="font-poppins text-[0.875rem] text-[#0FB23C] font-semibold text-center my-[0.5rem]">{orderBookData.total}</p>

								{orderBookData.buys
									.sort((a, b) => parseInt(a.amount, 10) - parseInt(b.amount, 10))
									.map(buy => {
										let percent = Math.round(Number((buy.amount * 100) / totalSellAmount));
										console.log(percent);

										return (
											<div style={{ backgroundSize: `${percent}% 100%` }} className='flex font-poppins text-[0.75rem] text-[#161616] items-center p-[0.5rem] w-[100%] justify-between bg-no-repeat bg-[url("https://res.cloudinary.com/ddlupbcws/image/upload/v1702042518/bg_nhz4om.webp")] bg-right'>
												<p>{buy.price}</p>
												<p>{buy.amount}</p>
											</div>
										);
									})}
							</div>
						</div>
						<div className="bg-white hidden lg:block mt-[1rem] p-[1.5rem] rounded-[0.75rem] shadow-[0_2px_16px_0_rgba(128,128,128,0.18)]">
							<h1 className="font-poppins text-[0.875rem] font-semibold text-[#161616] text-center mb-[1rem]">Most Traded Stocks</h1>
							<MostTradedStockTable data={mostTradedStock} />
						</div>
						<div className="bg-white hidden lg:block mt-[1rem] p-[1.5rem] rounded-[0.75rem] shadow-[0_2px_16px_0_rgba(128,128,128,0.18)]">
							<h1 className="font-poppins text-[0.875rem] font-semibold text-[#161616] text-center mb-[1.5rem]">Chart Source Toggle</h1>
							<div className="relative bg-[#F8F9FA] rounded-[1rem] p-[0.25rem] shadow-inner">
								<div className="flex items-center  gap-[1rem] relative">
									<button 
										onClick={() => handleChartSourceChange('NGX')}
										disabled={isTransitioning}
										className={`
											relative z-10 font-poppins w-[50%] text-[0.875rem] font-semibold text-center px-[1.5rem] py-[0.75rem] rounded-[0.75rem] transition-all duration-500 ease-[cubic-bezier(0.4,0,0.2,1)] transform hover:scale-105 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed
											${chartSource === 'NGX' 
												? 'bg-gradient-to-r from-[#0FB23C] to-[#0A8A2E] text-white shadow-lg shadow-[#0FB23C]/30' 
												: 'bg-white text-[#161616] hover:bg-[#F0F0F0] border border-[#E5E5E5]'
											}
										`}
									>
										<span className="flex items-center gap-[0.5rem]">
											<svg className="w-[1rem] h-[1rem]" fill="currentColor" viewBox="0 0 20 20">
												<path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" clipRule="evenodd" />
											</svg>
											NGX
										</span>
									</button>
									
									<button 
										onClick={() => handleChartSourceChange('Tradingview')}
										disabled={isTransitioning}
										className={`
											relative z-10 font-poppins text-[0.875rem] w-[50%] font-semibold text-center px-[1.5rem] py-[0.75rem] rounded-[0.75rem] transition-all duration-500 ease-[cubic-bezier(0.4,0,0.2,1)] transform hover:scale-105 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed
											${chartSource === 'Tradingview' 
												? 'bg-gradient-to-r from-[#FF6B35] to-[#E55A2B] text-white shadow-lg shadow-[#FF6B35]/30' 
												: 'bg-white text-[#161616] hover:bg-[#F0F0F0] border border-[#E5E5E5]'
											}
										`}
									>
										<span className="flex items-center gap-[0.5rem]">
											<svg className="w-[1rem] h-[1rem]" fill="currentColor" viewBox="0 0 20 20">
												<path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" />
											</svg>
											TradingView
										</span>
									</button>
								</div>
								{/* Enhanced animated background indicator */}
								<div 
									className={`absolute top-[0.25rem] bottom-[0.25rem] rounded-[0.75rem] transition-all duration-700 ease-[cubic-bezier(0.4,0,0.2,1)] shadow-lg ${
										chartSource === 'NGX' 
											? 'left-[0.25rem] w-[calc(50%-0.125rem)] bg-gradient-to-r from-[#0FB23C] to-[#0A8A2E]' 
											: 'left-[calc(50%+0.125rem)] w-[calc(50%-0.125rem)] bg-gradient-to-r from-[#FF6B35] to-[#E55A2B]'
									}`}
								></div>
							</div>
							{/* Status indicator */}
							<div className="flex items-center justify-center mt-[1rem]">
								<div className={`flex items-center gap-[0.5rem] px-[1rem] py-[0.5rem] rounded-[0.5rem] text-[0.75rem] font-medium ${
									chartSource === 'NGX' 
										? 'bg-[#0FB23C]/10] text-[#0FB23C]' 
										: 'bg-[#FF6B35]/10] text-[#FF6B35]'
								}`}>
									<div className={`w-[0.5rem] h-[0.5rem] rounded-full animate-pulse ${
										chartSource === 'NGX' ? 'bg-[#0FB23C]' : 'bg-[#FF6B35]'
									}`}></div>
									{isTransitioning ? 'Updating...' : (chartSource === 'NGX' ? 'NGX Data Source' : 'TradingView Data Source')}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Analytics;
